import AsyncStorage from '@/utils/async-storage-chunker';
import { CreditRequestBatchLineItem } from '@/contexts/credit-request-context-types';

export class CreditRequestBasketStorageAdapter {
  restaurantUUID: string;
  supplierUUID: string;

  constructor(restaurantUUID: string, supplierUUID: string) {
    this.restaurantUUID = restaurantUUID;
    this.supplierUUID = supplierUUID;
  }

  get cacheKey(): string {
    return `CreditRequest_${this.supplierUUID}_${this.restaurantUUID}`;
  }

  async fetch(): Promise<CreditRequestBatchLineItem[] | null> {
    const creditRequestData = await AsyncStorage.getItem(this.cacheKey);
    return creditRequestData ? JSON.parse(creditRequestData) : null;
  }

  async remove(): Promise<void> {
    await AsyncStorage.removeItem(this.cacheKey);
  }

  async save(creditRequestData: CreditRequestBatchLineItem[]): Promise<void> {
    await AsyncStorage.setItem(
      this.cacheKey,
      JSON.stringify(creditRequestData),
    );
  }
}
